export const HeadingGeneralStylings = {
  fontFamily: "larsseit",
  fontFeatureSettings: '"ss01" on, "ss02" on',
  fontWeight: "normal",
  letterSpacing: "-0.02em",
  color: "inherit",
}

export const Heading = {
  baseStyle: {
    ...HeadingGeneralStylings,
    _hover: {
      textDecoration: "none",
    },
    _activeLink: {
      textDecoration: "none",
    },
  },
  // rebrand-graphik: small headings (h6) use Graphik 500; larger headings (h1–h5) stay Larsseit.
  sizes: {
    carouselHero: {
      fontSize: { base: "3rem", md: "5rem" },
      lineHeight: 1.25,
    },
    h1: {
      fontSize: ["4rem", "5rem"],
      lineHeight: 1.25,
    },
    h2: {
      fontSize: ["3rem", "4rem"],
      lineHeight: 1.25,
    },
    h3: {
      fontSize: ["2rem", "3rem"],
      lineHeight: 1.25,
    },
    h4: {
      fontSize: ["1.5rem", "2rem"],
      lineHeight: 1.4,
    },
    h5: {
      fontSize: ["1.25rem", "2rem"],
      lineHeight: 1.4,
    },
    h6: {
      fontFamily: "graphik",
      fontWeight: "medium",
      fontSize: "1.125rem",
      lineHeight: 1.4,
    },
  },
  variants: {
    mono: {
      fontFamily: "mono",
    },
    normal: {
      fontWeight: "normal",
    },
    medium: {
      fontWeight: "medium",
    },
    bold: {
      fontWeight: "bold",
    },
  },
}
